import React from "react";
import "./MedicalServicesPage.css";

const MedicalServicesPage = () => {
  return (
    <>
      <div className="medicalServicesSection">
        <h2>Your Health, Our Priority – Medical Services at SwasthMitra</h2>
        <div className="medicalServicesContent">
          <p>
            At <strong>SwasthMitra</strong>, we go beyond just delivering medicines — we offer a <strong>comprehensive range of healthcare services</strong> designed to make your life easier, healthier, and more informed.
          </p>
          <p>
            Whether it's a quick consultation, managing a chronic illness, or ensuring your loved ones get the right care at the right time — we're here for you.
          </p>

          <hr />

          <h3>🔹 Our Core Medical Services</h3>

          <div className="serviceCategory">
            <h4>💊 1. Online Pharmacy – 100% Genuine Medicines</h4>
            <p>
              Get doctor-prescribed medicines and over-the-counter (OTC) products delivered safely to your doorstep.
            </p>
            <ul>
              <li>Branded & Generic Medicines</li>
              <li>Health Supplements & Wellness Products</li>
              <li>COVID Essentials, First Aid, and more</li>
              <li>Timely refills and subscription options</li>
            </ul>
            <div className="serviceHighlight">
              <p><strong>Why choose us?</strong></p>
              <p>✔ Verified suppliers only</p>
              <p>✔ Cold-chain compliance for sensitive meds</p>
              <p>✔ Affordable pricing & discounts</p>
            </div>
          </div>

          <div className="serviceCategory">
            <h4>🩻 2. Diagnostic Test Booking (Coming Soon!)</h4>
            <p>
              Convenient lab test booking from trusted labs — right from your home.
            </p>
            <ul>
              <li>Blood tests, health packages, sugar tests, etc.</li>
              <li>Sample collection from home</li>
              <li>Digital reports delivered to your phone</li>
            </ul>
            <p className="comingSoonNote">
              (Service rolling out soon – stay tuned!)
            </p>
          </div>

          <div className="serviceCategory">
            <h4>👨‍⚕ 3. Teleconsultation with Certified Doctors (Coming Soon!)</h4>
            <p>
              Need a quick consultation? Our partner doctors are just a video call away.
            </p>
            <ul>
              <li>General Physician Consultations</li>
              <li>Specialist Referrals</li>
              <li>Prescription Support</li>
              <li>Follow-up Reminders</li>
            </ul>
            <div className="serviceHighlight">
              <p><strong>Get expert advice</strong> without stepping out of your home.</p>
            </div>
            <p className="comingSoonNote">
              (Service rolling out soon – stay tuned!)
            </p>
          </div>

          <div className="serviceCategory">
            <h4>🤝 4. Health Relationship Management</h4>
            <p>
              We assign <strong>dedicated Relationship Managers</strong> to support:
            </p>
            <ul>
              <li>Senior citizens / chronic illness patients</li>
              <li>Medicine scheduling and tracking</li>
              <li>Family health management</li>
              <li>Personalized reminders & care coordination</li>
            </ul>
            <div className="serviceHighlight">
              <p><strong>Human help</strong> when you need it most.</p>
            </div>
          </div>

          <div className="serviceCategory">
            <h4>📈 5. Affiliate & Wellness Partner Programs</h4>
            <p>
              Are you a health professional, influencer, or wellness coach?
              Join our <strong>Affiliate Program</strong> or become a <strong>SwasthMitra Wellness Partner</strong> and earn while you help others access genuine healthcare.
            </p>
            <div className="serviceHighlight">
              <p>✅ Zero investment</p>
              <p>✅ High commissions</p>
              <p>✅ Exclusive deals for your community</p>
            </div>
          </div>

          <hr />

          <h3>🌟 Why SwasthMitra?</h3>
          <div className="whyChooseUs">
            <p>✔ 100% Genuine & Verified Products</p>
            <p>✔ Trusted by thousands across India</p>
            <p>✔ Human Support + Digital Convenience</p>
            <p>✔ Health-first approach — not just business</p>
          </div>

          <hr />

          <div className="contactSection">
            <h3>💬 Have Questions?</h3>
            <p>
              Contact us today and let us help you with the right solution.
              <br />
              📞 <a href="tel:+917007512120">+91-7007512120</a> | 📧 <a href="mailto:info@swasthmitra.com">info@swasthmitra.com</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MedicalServicesPage;